<script>
import chat from "../components/chat";
import auctionVessels from "../components/auctionVessels";
import requirementSummary from "../components/requirementSummary";
import bidderToolbar from "../components/bidderToolbar";
import hostToolbar from "../components/hostToolbar";
import bidEntry from "../components/bidEntry";
import autobidEntry from "../components/autobidEntry";
import signalR from "../components/signalR";
import auctionStatus from "../components/auctionStatus";
import multiVesselOffer from "../components/multiVesselOffer";
import multiVesselOffers from "../components/multiVesselOffers";
import auctionTimer from "../components/auctionTimer";
import triggerAuctionModal from "../components/triggerAuctionModal";
import fuelPriceModal from "../components/fuelPriceModal";
import toggle from "../components/toggle";
import dropdown from "@/components/form components/dropdown";

export default {
  name: "auction",
  components: {
    chat,
    auctionVessels,
    requirementSummary,
    bidderToolbar,
    bidEntry,
    autobidEntry,
    signalR,
    auctionStatus,
    hostToolbar,
    multiVesselOffer,
    multiVesselOffers,
    auctionTimer,
    triggerAuctionModal,
    toggle,
    fuelPriceModal,
    dropdown,
  },
  data: function() {
    return {
      refreshChat: 0,
      refreshBidList: 0,
      showFuel: true,
      bidsActive: false,
      newMVO: false,
      mvoTabActive: false,
    };
  },
  methods: {
    async onRefreshBidList() {
      await this.setActiveAuction();
      this.refreshBidList++;
    },
    async setActiveAuction(isInitialLoad) {
      if (isInitialLoad) {
        this.$store.commit("setLoadingAnimation", {
          show: true,
          text: "Getting Auction Data",
        });
      }

      var result = await this.$store.dispatch("getRequest", { controller: "auction", method: `GetAuction/${this.$route.params.id}` });
      var activeAuction = result.auction;
      //need to deserialise offers
      this.$store.commit("hideLoadingAnimation");
      for (var i = 0; i < activeAuction.bids.length; i++) {
        activeAuction.bids[i].offer = JSON.parse(activeAuction.bids[i].offer);
      }
      await this.$store.commit("setActiveAuction", activeAuction);
    },
    async onAuctionStart() {
      console.log("Auction Started");
      await this.setActiveAuction();
      this.refreshChat++;
    },
    async onAuctionStop() {
      console.log("Auction Stopped");
      await this.setActiveAuction();
      this.refreshChat++;
    },
    async onAuctionExtended(seconds) {
      console.log(`Auction extended by ${seconds} seconds`);
      this.$store.commit("setAuctionExtend", seconds);
      this.refreshChat++;

      await this.setActiveAuction();
    },
    onRefreshChatLog: function(bidId, userId) {
      var self = this;
      self.refreshChat++;
      if (bidId) {
        if (self.$store.state.latestBidMessageId == bidId && userId != self.userId) {
          self.$store.commit("setNewBidMessage", null);
          self.$nextTick(function() {
            self.$store.commit("setNewBidMessage", bidId);
          });
        } else if (userId != self.userId) {
          self.$store.commit("setNewBidMessage", bidId);
        }
      }
    },
    onSetActiveVessel: function(bid, vesselName) {
      this.$store.commit("setActiveBid", bid);
      this.$store.commit("setActiveVesselName", vesselName);
    },
    async onDestroyed() {
      var self = this;
      const Http = new XMLHttpRequest();
      var url = `${process.env.VUE_APP_API_URL}/auction/RemoveActiveBidder/${this.activeAuction.id}?userId=${self.$store.state.userId}`;
      Http.open("GET", url);
      Http.send();
    },
    async onBeforeUnload() {
      this.onDestroyed();
      window.removeEventListener("beforeunload", self.onBeforeUnload);
    },
    onClickToggle() {
      this.showFuel = !this.showFuel;
    },
    onClickFuelEdit() {
      this.$store.commit("toggleFuelPriceModal", true);
    },
    getChatColumnClass() {
      if (!this.showVesselList) {
        return "col-12";
      } else if (this.isSmallScreen) {
        return "col-8";
      } else if (this.navbarExpandedOverlay) {
        return "col-sm-6";
      } else if (this.showFuelDetails) {
        return "col-lg-7 col-md-12";
      } else {
        return "col-lg-8 col-md-12";
      }
    },
    getVesselColumnClass() {
      if (this.isSmallScreen) {
        return "col-4";
      } else if (this.navbarExpandedOverlay) {
        return "col-sm-6";
      } else if (this.showFuelDetails) {
        return "col-lg-5 col-md-12";
      } else {
        return "col-lg-4 col-md-12";
      }
    },
    onChangeActiveBid(offerId) {
      var activeBid = this.activeAuction.bids.filter(function(x) {
        return x.offerId == offerId;
      })[0];
      this.$store.commit("setActiveBid", activeBid);

      this.$store.commit("setActiveVesselName", activeBid.vesselName);
    },
    onBidsTabClick() {
      this.bidsActive = true;
      this.mvoTabActive = false;
      this.$store.commit("setNewMessage", false);
    },
    onNewMVO() {
      this.newMVO = true;
    },
  },
  computed: {
    activeAuction: function() {
      return this.$store.state.activeAuction || null;
    },
    activeBid: function() {
      return this.$store.state.activeBid || null;
    },
    requirementSummary: function() {
      return this.$store.state.activeAuction.requirementSummary;
    },
    userRole: function() {
      return this.$store.state.role;
    },
    userId: function() {
      return this.$store.state.userId;
    },
    isCharterer: function() {
      return this.userRole == "CHA";
    },
    isOwner: function() {
      return this.userRole == "OWN";
    },
    isInternal: function() {
      return this.userRole == "SHP" || this.userRole == "ADM" || this.userRole == "ALY";
    },
    showVesselList: function() {
      return this.isCharterer || this.isInternal || this.activeAuction.bids.length > 1;
    },
    multiVesselOffers: function() {
      return this.$store.state.activeAuction ? this.$store.state.activeAuction.multiVesselOffers : null;
    },
    hasMultiVessel: function() {
      return this.multiVesselOffers == null ? false : this.multiVesselOffers.length > 0 ? true : false;
    },
    isSmallScreen() {
      return this.$store.state.isSmallScreen;
    },
    isMobile() {
      return this.$store.state.isMobile;
    },
    fuelPrice() {
      return this.$store.state.fuelPrice;
    },
    fuelUnit() {
      return this.$store.state.fuelUnit;
    },
    currency: function() {
      return this.$store.state.activeAuction.currency;
    },
    showFuelDetails() {
      return this.$store.state.activeAuction.includeFuelCost && !this.isOwner;
    },
    customFuelPriceDisplay: function() {
      if (!this.fuelPrice || !this.fuelUnit) {
        return "not specified";
      }
      return `${this.currency} ${this.fuelPrice} per ${this.fuelUnit == "M" ? "m³" : "tonne"}`;
    },
    navbarExpandedOverlay() {
      return this.$store.state.navbarExpandedOverlay;
    },
    bidDropdownData: function() {
      return this.activeAuction.bids.map(function(o) {
        return { Key: o.offerId, Value: o.vesselName };
      });
    },
    showBidMessageIcon() {
      return !this.bidsActive && this.$store.state.showNewMessage;
    },
    showNewMVO() {
      return this.newMVO && !this.mvoTabActive && !this.isOwner;
    },
  },
  async mounted() {
    await this.setActiveAuction(true);
    if (this.isOwner) {
      var self = this;
      await self.$store.dispatch("postRequest", { controller: "auction", method: `AddActiveBidder/${this.activeAuction.id}` });
    }
  },
  created: function() {
    window.addEventListener("beforeunload", this.onBeforeUnload);
  },
  async destroyed() {
    if (this.isOwner) {
      this.onDestroyed();
    }
    await this.$store.commit("setActiveAuction", null);
  },
  watch: {
    mvoTabActive(val) {
      this.newMVO = false;
    },
  },
};
</script>

<template>
  <div v-if="activeAuction">
    <auction-timer v-if="isMobile" class="fixed-timer"></auction-timer>
    <div style="position:absolute;top:10px;left:10px;z-index:10"></div>
    <div class="row">
      <div class="col-12">
        <auction-status></auction-status>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <requirement-summary></requirement-summary>
      </div>
    </div>
    <div style="margin-bottom:0.5rem;">
      <host-toolbar v-if="!isOwner" class="row"></host-toolbar>
      <bidder-toolbar v-else class="row" :refreshBidList="refreshBidList"></bidder-toolbar>
    </div>

    <div class="row" id="message-part-wrapper" v-if="!isMobile">
      <div :class="getChatColumnClass()" class="chat">
        <chat :refreshChat="refreshChat" v-if="!isOwner || (isOwner && activeBid)"></chat>
      </div>
      <div :class="getVesselColumnClass()" class="vessels" v-if="showVesselList">
        <div v-if="hasMultiVessel">
          <b-tabs fill>
            <b-tab active v-on:click="onBidsTabClick()">
              <template v-slot:title> <span v-if="isOwner">My </span>Bids ({{ activeAuction.bids.length }}) <i v-if="showBidMessageIcon" class="fas fa-comment icon-right icon-shake"></i></template>
              <span v-if="showFuelDetails" v-on:click="onClickFuelEdit" class="custom-fuel-price"
                ><span v-if="!isSmallScreen">Fuel Price: {{ customFuelPriceDisplay }}<i class="change" title="Click here to change estimated fuel price">Change</i></span
                ><span v-else><i class="fas fa-gas-pump"></i></span
              ></span>
              <toggle v-if="showFuelDetails" style="float:right;margin-right:5px;" v-on:onClick="onClickToggle" :thisValue="showFuel" label="Sort by Total Cost"></toggle><br v-if="showFuelDetails" />
              <auction-vessels :refreshBidList="refreshBidList" :showFuel="showFuel && showFuelDetails"></auction-vessels>
            </b-tab>
            <b-tab
              v-on:click="
                mvoTabActive = true;
                bidsActive = false;
              "
            >
              <template v-slot:title>
                <span> <span v-if="isOwner">My </span>Package Offers ({{ activeAuction.multiVesselOffers.length }})</span><span v-if="showNewMVO" class="new-icon icon-shake" title="A new package offer has been added">New!</span></template
              >
              <div style="max-height:600px;overflow:auto;">
                <multi-vessel-offers v-on:newMVO="onNewMVO()"></multi-vessel-offers>
              </div>
            </b-tab>
          </b-tabs>
        </div>
        <div v-else>
          <span v-if="showFuelDetails" v-on:click="onClickFuelEdit" class="custom-fuel-price"
            ><span v-if="!isSmallScreen">Fuel Price: {{ customFuelPriceDisplay }}<i class="change" title="Click here to change estimated fuel price">Change</i></span
            ><span v-else><i class="fas fa-gas-pump"></i></span
          ></span>
          <toggle v-if="showFuelDetails" style="float:right;margin-right:5px;" v-on:onClick="onClickToggle" :thisValue="showFuel" label="Sort by Total Cost"></toggle><br v-if="showFuelDetails" />
          <auction-vessels :refreshBidList="refreshBidList" :showFuel="showFuel && showFuelDetails"></auction-vessels>
        </div>
      </div>
    </div>
    <div class="row" id="message-part-wrapper-mobile" v-else>
      <div class="col-12">
        <b-tabs fill v-if="!isOwner || (isOwner && hasMultiVessel)">
          <b-tab
            v-if="!isOwner"
            title="Activity"
            active
            v-on:click="
              bidsActive = false;
              mvoTabActive = false;
            "
          >
            <div class="chat">
              <chat :refreshChat="refreshChat" :generalOnly="true"></chat>
            </div>
          </b-tab>
          <b-tab v-on:click="onBidsTabClick()" :active="isOwner">
            <template v-slot:title>
              <span> <span v-if="isOwner">My </span>Bids </span> <i v-if="showBidMessageIcon" class="fas fa-comment icon-right icon-shake"></i>
            </template>
            <div class="vessels">
              <auction-vessels style="margin-top:0.5rem" :refreshChat="refreshChat" :refreshBidList="refreshBidList" :showFuel="showFuel && showFuelDetails"></auction-vessels>
            </div>
          </b-tab>
          <b-tab
            v-if="hasMultiVessel"
            v-on:click="
              bidsActive = false;
              mvoTabActive = true;
            "
          >
            <template v-slot:title> <span v-if="isOwner">My </span>Package Offers ({{ activeAuction.multiVesselOffers.length }}) <span v-if="showNewMVO" class="new-icon icon-shake" title="A new package offer has been added">New!</span></template>
            <div class="vessels">
              <multi-vessel-offers v-on:newMVO="onNewMVO()" style="margin-top:0.5rem;"></multi-vessel-offers>
            </div>
          </b-tab>
        </b-tabs>
        <div v-else>
          <span class="title-text">My Bids <i v-if="!activeBid" style="font-weight:normal"> (Click on a vessel to enable bid actions)</i></span>
          <div class="vessels">
            <auction-vessels :refreshChat="refreshChat" :refreshBidList="refreshBidList" :showFuel="showFuel && showFuelDetails"></auction-vessels>
          </div>
        </div>
      </div>
    </div>
    <bid-entry></bid-entry>
    <autobid-entry v-on:bidLimitUpdated="onRefreshBidList"></autobid-entry>
    <signal-r v-if="activeAuction && activeAuction.id" v-on:refreshChatLog="onRefreshChatLog" v-on:refreshBidList="onRefreshBidList" v-on:onAuctionStart="onAuctionStart" v-on:onAuctionStop="onAuctionStop" v-on:onAuctionExtend="onAuctionExtended"></signal-r>
    <multi-vessel-offer v-if="isOwner"></multi-vessel-offer>
    <trigger-auction-modal></trigger-auction-modal>
    <fuel-price-modal></fuel-price-modal>
  </div>
</template>

<style scoped>
.fixed-timer {
  position: fixed;
  top: 10px;
  right: 10px;
  z-index: 999;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 999px;
}
.custom-fuel-price {
  font-size: 12px;
}
.custom-fuel-price .change {
  margin-left: 5px;
  color: #007bff;
}
.custom-fuel-price .change:hover {
  cursor: pointer;
  text-decoration: underline;
}
.fa-gas-pump {
  color: #004996;
  font-size: 16px;
}
.new-icon {
  font-size: 11px;
  margin-left: 10px;
  display: inline-block;
}
</style>
